import Loadable from 'react-loadable';
import Skeleton from '@material-ui/lab/Skeleton';

const SeeMoreAnchorLink = Loadable({
  loader: () => import('./ParticleEffect.js'),
  loading: Skeleton,
});

export default SeeMoreAnchorLink;
